
import { Form, Field, CellGroup, Button, Toast } from 'vant'
import { reactive } from '@vue/reactivity'
import { savaAdress } from '@/api/sdws.js'

export default {
  components: {
    Form,
    Field,
    CellGroup,
    Button
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['received', 'close'],
  setup(props, ctx) {
    const form = reactive({
      name: '',
      mobile: '',
      address: ''
    })

    const onSubmit = async () => {
      if (!form.name) {
        Toast('请填写姓名')

        return
      }
      if (!form.mobile) {
        Toast('请填写手机')

        return
      }
      if (!form.address) {
        Toast('请填写收货地址')

        return
      }
      const res = await savaAdress({
        ...form
      })

      if (res.ok) {
        Toast(res.comment)
        ctx.emit('received')
      }
    }

    return {
      form,
      onSubmit
    }
  }
}
